export default __webpack_public_path__ + "static/media/GothamSSm-ExtraLight.56a4ea95.ttf";